import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

firebase.initializeApp({
  apiKey: 'AIzaSyDPAxDID7KslGtS-UdrkOVgUVXiIIRjg5k',
  authDomain: 'mas-la-font.firebaseapp.com',
  databaseURL: 'https://mas-la-font-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'mas-la-font',
  storageBucket: 'mas-la-font.appspot.com',
  messagingSenderId: '441247047620',
  appId: '1:441247047620:web:9418d4eced42eef2620e91',
});

export default firebase;